import { isProduction } from '@/modules/env/isProduction';

export function createShopDropQuery(username: string) {
  return `query getShopDropByUsername {
    influencerCollection(where: { username: "${username}" }, preview: ${!isProduction()}, limit: 1) {
      items {
        username
        bio
        useInfluencerLayout
        instagramFollowers
        tikTokFollowers
        youTubeFollowers
        depopFollowers
        desktopBanner {
          url
          width
          height
        }
        mobileBanner {
          url
          width
          height
        }
        dropsCollection(limit: 1, order: dropDate_DESC) {
          items {
            dropDate
            countdownDate
            endDate
            timeZone
            dropInfo
            notificationDate
            triggerNotification
          }
        }
      }
    }
  }`;
}
